import React from 'react'
import ActionButton from '../../input/buttons/button/SarasButton'
import * as fn from "../../../helper/uiFunctions";

const FormSH = (props) => {
    //this should be default format for reading props for all form controls
    const {formObject, action, rowKey, headerKey, className, icon, ...restProps} = props;

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    let hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

    //hide control if the action is edit but document id is not available (it means the document is still not selected)
    if(action.actionId === "edit" && (viewData && (!viewData.val || fn.compareNumber(viewData.val, 0)))){
        hide = "1";
    }
    
    const onButtonClick = (e) => {
        let customAction = {...action, skipMasterKey: 1};
        
        //TODO give support for dashboard
        if (!customAction.actionParam) {
            customAction["actionParam"] = {};
        }

        let params = formObject.getDependantValue(action.actionParam, rowKey, headerKey, action.paramName)
        customAction.actionParam = {...customAction.actionParam, ...params};

        customAction.actionParam["showModeID"] = "sh";
        customAction.actionParam["dtId"] = viewData.dataList.valLDT;
        customAction.actionParam["ctgId"] = viewData.dataList.valLCat;
        if(customAction.actionId === "edit"){
            customAction.actionParam["dId"] = viewData.val;
        }

        customAction["actionName"] = formObject.getValueFromKey(viewData, "dataList.actionName", action.actionName);

        if (customAction.actionId) formObject.onFormAction(customAction, rowKey, headerKey);
    }

    //if hide is 1 it means do not render, if hide is missing or is 0 it means do not hide
    if(hide === "0"){
        return (
            <ActionButton onClick={onButtonClick} 
            starIcon={icon || action.actionId === "edit" ? "edit" : "adds"}
            tooltip={action.actionId === "edit" ? "Edit" : "Add"}
            onlyIcon={true}
            className="uiLink uiIcon" 
            // className={className || "uiActionIconRound uiColorAction"}
             {...restProps} />
        )
    }

    return (null);
}

export default FormSH;
